"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var TableMenuIsLocked_1 = require("../../../../../../shared/components/table_menus/TableMenuIsLocked");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionView_1 = require("../../../../../../shared/components/table_actions/TableActionView");
var TableActionStats_1 = require("../../../../../../shared/components/table_actions/TableActionStats");
var TableActionLockLock_1 = require("../../../../../../shared/components/table_actions/TableActionLockLock");
var FireWallRulesList = /** @class */ (function (_super) {
    __extends(FireWallRulesList, _super);
    function FireWallRulesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchDescriptionInput = null;
        _this.searchIpInput = null;
        _this.searchFingerprintInput = null;
        _this.searchUserAgentInput = null;
        return _this;
    }
    FireWallRulesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            searchIpFilter: [],
            searchIpValue: "",
            searchFingerprintFilter: [],
            searchFingerprintValue: "",
            //---------------------------
            searchUserAgentFilter: [],
            searchUserAgentValue: ""
        }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FireWallRulesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    FireWallRulesList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                nextProps.data.LoadData(_this.props.allBrands, _this.props.brandsList);
            });
        }
    };
    FireWallRulesList.prototype.doLockUnlockAction = function (key, title, lock) {
        this.props.data.doSetIsLocked(key, lock, function () {
            if (lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u0444\u0430\u0439\u0435\u0440\u0432\u043E\u043B\u0430 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u0444\u0430\u0439\u0435\u0440\u0432\u043E\u043B\u0430 \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E"));
            }
        });
    };
    FireWallRulesList.prototype.onClearDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [], searchDescriptionValue: "" });
    };
    FireWallRulesList.prototype.onChangeDescriptionFilter = function (e) {
        this.setState({ searchDescriptionValue: e.target.value });
    };
    FireWallRulesList.prototype.onConfirmDescriptionFilter = function () {
        this.setState({ searchDescriptionFilter: [this.state.searchDescriptionValue] });
    };
    FireWallRulesList.prototype.onClearIpFilter = function () {
        this.setState({ searchIpFilter: [], searchIpValue: "" });
    };
    FireWallRulesList.prototype.onChangeIpFilter = function (e) {
        this.setState({ searchIpValue: e.target.value });
    };
    FireWallRulesList.prototype.onConfirmIpFilter = function () {
        this.setState({ searchIpFilter: [this.state.searchIpValue] });
    };
    FireWallRulesList.prototype.onClearFingerprintFilter = function () {
        this.setState({ searchFingerprintFilter: [], searchFingerprintValue: "" });
    };
    FireWallRulesList.prototype.onChangeFingerprintFilter = function (e) {
        this.setState({ searchFingerprintValue: e.target.value });
    };
    FireWallRulesList.prototype.onConfirmFingerprintFilter = function () {
        this.setState({ searchFingerprintFilter: [this.state.searchFingerprintValue] });
    };
    FireWallRulesList.prototype.onClearUseragentFilter = function () {
        this.setState({ searchUserAgentFilter: [], searchUserAgentValue: "" });
    };
    FireWallRulesList.prototype.onChangeUseragentFilter = function (e) {
        this.setState({ searchUserAgentValue: e.target.value });
    };
    FireWallRulesList.prototype.onConfirmUseragentFilter = function () {
        this.setState({ searchUserAgentFilter: [this.state.searchUserAgentValue] });
    };
    FireWallRulesList.prototype.getColumns = function () {
        var _this = this;
        var _description_filter = this.state.searchDescriptionFilter;
        var _ip_filter = this.state.searchIpFilter;
        var _fingerprint_filter = this.state.searchFingerprintFilter;
        var _useragent_filter = this.state.searchUserAgentFilter;
        return [{
                title: 'Событие',
                dataIndex: this.props.data.dk_firewall_event_title,
                key: this.props.data.dk_firewall_event_title,
                width: 150,
            }, {
                title: 'Ip адрес',
                dataIndex: this.props.data.dk_ip_address,
                key: this.props.data.dk_ip_address,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchIpInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E ip", value: _this.state.searchIpValue, onChange: _this.onChangeIpFilter.bind(_this), onPressEnter: function () { _this.onConfirmIpFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmIpFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearIpFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _ip_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.ip_address.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchIpInput.focus();
                        });
                    }
                }, render: function (text, record, idx) {
                    if (record.is_control_ip) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.ip_address));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.ip_address));
                    }
                }
            },
            {
                title: 'Юзерагент',
                dataIndex: this.props.data.dk_useragent,
                key: this.props.data.dk_useragent,
                width: 150,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchUserAgentInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u044E\u0437\u0435\u0440\u0430\u0433\u0435\u043D\u0442\u0443", value: _this.state.searchUserAgentValue, onChange: _this.onChangeUseragentFilter.bind(_this), onPressEnter: function () { _this.onConfirmUseragentFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmUseragentFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearUseragentFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _useragent_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.useragent.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchUserAgentInput.focus();
                        });
                    }
                }, render: function (text, record, idx) {
                    if (record.is_control_useragent) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.useragent));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.useragent));
                    }
                }
            }, {
                title: 'Почта',
                dataIndex: this.props.data.dk_email_part,
                key: this.props.data.dk_email_part,
                width: 150,
                render: function (text, record, idx) {
                    if (record.is_control_email_part) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.email_part));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.email_part));
                    }
                }
            }, {
                title: 'Провайдер',
                dataIndex: this.props.data.dk_isp_provider,
                key: this.props.data.dk_isp_provider,
                width: 150,
                render: function (text, record, idx) {
                    if (record.is_control_isp_provider) {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "green" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                            " ",
                            record.isp_provider));
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("span", { style: { color: "red" } },
                                React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                            " ",
                            record.isp_provider));
                    }
                }
            }, {
                title: 'Коды стран:',
                children: [{
                        title: 'включая',
                        dataIndex: this.props.data.dk_specified_country_code,
                        key: this.props.data.dk_specified_country_code,
                        width: 150,
                        render: function (text, record, idx) {
                            if (record.is_control_specified_country_code) {
                                return (React.createElement("div", null,
                                    React.createElement("span", { style: { color: "green" } },
                                        React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                                    " ",
                                    record.specified_country_code));
                            }
                            else {
                                return (React.createElement("div", null,
                                    React.createElement("span", { style: { color: "red" } },
                                        React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                                    " ",
                                    record.specified_country_code));
                            }
                        }
                    }, {
                        title: 'исключая',
                        dataIndex: this.props.data.dk_except_the_specified_country_code,
                        key: this.props.data.dk_except_the_specified_country_code,
                        width: 150,
                        render: function (text, record, idx) {
                            if (record.is_control_except_the_specified_country_code) {
                                return (React.createElement("div", null,
                                    React.createElement("span", { style: { color: "green" } },
                                        React.createElement(FontAwesome_1.FA, { right: true, icon: "check" })),
                                    " ",
                                    record.except_the_specified_country_code));
                            }
                            else {
                                return (React.createElement("div", null,
                                    React.createElement("span", { style: { color: "red" } },
                                        React.createElement(FontAwesome_1.FA, { right: true, icon: "times" })),
                                    " ",
                                    record.except_the_specified_country_code));
                            }
                        }
                    }]
            },
            {
                title: 'Действие',
                dataIndex: this.props.data.dk_on_detect_action_title,
                key: this.props.data.dk_on_detect_action_title,
                width: 150,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать правило", text: "Да" }, unlockedTexts: { menu: "Разблокировать правило", text: "Нет" }, record: { key: record.key, title: "правило", locked: record.is_locked }, onLockClick: _this.doLockUnlockAction.bind(_this) }));
                },
                width: 150
            }, {
                title: 'Комментарий',
                dataIndex: this.props.data.dk_description,
                key: this.props.data.dk_description,
                width: 250,
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchDescriptionInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u044E", value: _this.state.searchDescriptionValue, onChange: _this.onChangeDescriptionFilter.bind(_this), onPressEnter: function () { _this.onConfirmDescriptionFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmDescriptionFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearDescriptionFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _description_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.description.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchDescriptionInput.focus();
                        });
                    }
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u043E", onClick: function () { _this.onEditClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u043E", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }),
                    React.createElement(TableActionStats_1.default, { hint: "\u041F\u043E\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432", onClick: function () { _this.onCountClick(record); } }),
                    React.createElement(TableActionLockLock_1.default, { hint: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432", confirmText: "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u044D\u0442\u043E\u043C\u0443 \u043F\u0440\u0430\u0432\u0438\u043B\u0443 ?", onClick: function () { _this.onLockClickClick(record); } }),
                    React.createElement(TableActionView_1.default, { hint: "\u0421\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432", onClick: function () { _this.onListAllClickClick(record); } }),
                    React.createElement(TableActionView_1.default, { hint: "\u0421\u043F\u0438\u0441\u043E\u043A \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432", onClick: function () { _this.onListAliveClickClick(record); } }))); },
                width: 110
            }
        ];
    };
    ;
    FireWallRulesList.prototype.onListAllClickClick = function (record) {
        var _this = this;
        this.props.data.getPlayersListCoveredByRule(record.key, function (count, playersAll, playersAlive) {
            _this.props.dlgSelectKeyVal.SetViewData(playersAll).SetTitle("Список игроков").SetOnSelectClick(function () { _this.props.dlgSelectKeyVal.Close(); }).SetOnCloseClick(function () { _this.props.dlgSelectKeyVal.Close(); }).Show();
        });
    };
    FireWallRulesList.prototype.onListAliveClickClick = function (record) {
        var _this = this;
        this.props.data.getPlayersListCoveredByRule(record.key, function (count, playersAll, playersAlive) {
            _this.props.dlgSelectKeyVal.SetViewData(playersAlive).SetTitle("Список игроков").SetOnSelectClick(function () { _this.props.dlgSelectKeyVal.Close(); }).SetOnCloseClick(function () { _this.props.dlgSelectKeyVal.Close(); }).Show();
        });
    };
    FireWallRulesList.prototype.onLockClickClick = function (record) {
        this.props.data.doBlockAllPlayersCoveredByRule(record.key, function (count) {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0411\u044B\u043B\u043E \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043E ",
                count,
                " \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u0440\u0430\u0432\u0438\u043B\u0443"));
        });
    };
    FireWallRulesList.prototype.onCountClick = function (record) {
        this.props.data.getPlayersCoveredByRuleCount(record.key, function (count) {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u043E\u0445\u0432\u0430\u0442\u044B\u0432\u0430\u0435\u0442 ",
                count,
                " \u0438\u0433\u0440\u043E\u043A\u043E\u0432"));
        });
    };
    FireWallRulesList.prototype.onEditClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    FireWallRulesList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteRule(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041F\u0440\u0430\u0432\u0438\u043B\u043E \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
        });
    };
    FireWallRulesList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(_this.props.allBrands, _this.props.brandsList, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    FireWallRulesList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.allBrands, this.props.brandsList);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
    };
    FireWallRulesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onBrandFilterChanged) {
            this.props.onBrandFilterChanged(allBrands, BrandId, Action);
        }
    };
    FireWallRulesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]")));
                }, scroll: { x: true } })));
    };
    return FireWallRulesList;
}(React.Component));
exports.default = FireWallRulesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/security_firewall/ui/component/FireWallRulesList.tsx
// module id = 2548
// module chunks = 0